import { Collapse, Form, Switch } from 'antd';
import { FormattedMessage } from 'react-intl';
// import TrackingInput from 'components/TrackingComponents/TrackingInput';
import { SwitchChangeEventHandler } from 'antd/lib/switch';
import RedInvoice from 'components/CreateStorePopup/components/RedInvoice';
import { SelectItem } from 'components/Select/Select';
import React, { FC } from 'react';
import styled from 'styled-components';
import utilsMessages from 'utils/messages';

interface VATInvoiceFormSectionProps {
  form: any;
  enabledVATInvoiceKey: boolean;
  onEnableGetVATInvoiceEvent: SwitchChangeEventHandler;
  resetDistrictAndWard: () => void;
  getDistrictsByCity: (city: string) => SelectItem[];
  resetWard: () => void;
  cities: SelectItem[];
  getWardsByCityAndDistrict: (city: string, district: string) => SelectItem[];
}

const { Panel } = Collapse;

const CustomPanel = styled(Panel)<any>`
  border-bottom: 0 !important;
  .ant-collapse-header {
    padding-left: 0 !important;
    padding-right: 0 !important;
    color: #595959 !important;
  }
  .ant-collapse-content-box {
    padding: 0 !important;
  }
  .ant-collapse-item {
    border-bottom: 0 !important;
  }

  .ant-collapse-arrow {
    right: 0 !important;
  }

  .ant-collapse-header {
    cursor: default !important;
  }
`;

const FormItem = styled(Form.Item)`
  margin-bottom: 12px !important;
`;

const RedInvoiceWrapper = styled.div`
  #first-row {
    flex-direction: column;
    & > div {
      flex: 0 0 100%;
      max-width: 100%;
    }
  }
`;

const VATInvoiceFormSection: FC<VATInvoiceFormSectionProps> = (props) => {
  const {
    enabledVATInvoiceKey,
    // resetDistrictAndWard,
    onEnableGetVATInvoiceEvent,
    // getDistrictsByCity,
    // resetWard,
    // getWardsByCityAndDistrict,
    // cities,
    form,
  } = props;
  // const [form as formTest] = Form.useForm();
  // const { getFieldValue } = form;
  // const [districtList, setDistrictList] = useState<any>([]);
  // const [wardList, setWardList] = useState<any>([]);

  // const onChangeCity = (value) => {
  //   const districtData = getDistrictsByCity(value);
  //   setDistrictList(districtData);
  //   resetDistrictAndWard();
  // };
  // const onChangeDistrict = (value) => {
  //   const wardData = getWardsByCityAndDistrict(getFieldValue('redInvoiceInfo')?.location?.city, value);
  //   setWardList(wardData);
  //   resetWard();
  // };
  return (
    <Collapse
      bordered={false}
      expandIcon={() => <Switch checked={enabledVATInvoiceKey} onChange={onEnableGetVATInvoiceEvent} />}
      expandIconPosition="end"
      activeKey={[enabledVATInvoiceKey ? 'VATInvoicePanel' : '']}
      style={{ backgroundColor: 'unset' }}
    >
      <CustomPanel
        header={<FormattedMessage {...utilsMessages.getVATInvoiceOrNot} />}
        collapsible="disabled"
        key="VATInvoicePanel"
      >
        {enabledVATInvoiceKey ? (
          <>
            {/* <FormattedMessage {...utilsMessages.companyName}>
              {(companyName) => (
                <FormattedMessage {...utilsMessages.fieldRequired} values={{ field: companyName }}>
                  {(fieldRequired) => (
                    <FormItem
                      name={['redInvoiceInfo', 'companyName']}
                      colon={false}
                      required={true}
                      label={companyName}
                      hasFeedback
                      rules={[{ required: true, message: fieldRequired }]}
                    >
                      <Input
                        InputComponent={AInput}
                        placeholder={companyName}
                        trackingCategory="Contact Us Form | Input"
                        trackingAction="Company Name"
                      />
                    </FormItem>
                  )}
                </FormattedMessage>
              )}
            </FormattedMessage>
            <FormattedMessage {...utilsMessages.taxCode}>
              {(taxCode) => (
                <FormattedMessage {...utilsMessages.fieldRequired} values={{ field: taxCode }}>
                  {(fieldRequired) => (
                    <FormItem
                      name={['redInvoiceInfo', 'taxCode']}
                      colon={false}
                      required={true}
                      label={taxCode}
                      rules={[{ required: true, message: fieldRequired }]}
                      hasFeedback
                    >
                      <Input
                        InputComponent={AInput}
                        placeholder={taxCode}
                        trackingCategory="Contact Us Form | Input"
                        trackingAction="Tax Code"
                      />
                    </FormItem>
                  )}
                </FormattedMessage>
              )}
            </FormattedMessage>
            <FormattedMessage {...utilsMessages.emailToReceiveEInvoice}>
              {(emailToReceiveEInvoice) => (
                <FormattedMessage {...utilsMessages.fieldRequired} values={{ field: emailToReceiveEInvoice }}>
                  {(fieldRequired) => (
                    <FormItem
                      name={['redInvoiceInfo', 'emailToReceiveEInvoice']}
                      colon={false}
                      required={true}
                      label={emailToReceiveEInvoice}
                      hasFeedback
                      rules={[
                        {
                          type: 'email',
                          message: translations(utilsMessages.fieldEmail),
                        },
                        { required: true, message: fieldRequired },
                      ]}
                      normalize={(value: string) => value && value.replace(/\s/g, '')}
                    >
                      <Input
                        InputComponent={AInput}
                        placeholder={emailToReceiveEInvoice}
                        trackingCategory="Contact Us Form | Input"
                        trackingAction="Enter Email to receive e-invoice"
                      />
                    </FormItem>
                  )}
                </FormattedMessage>
              )}
            </FormattedMessage>
            <Address
              form={form}
              fieldNameFullText={{
                city: ['redInvoiceInfo', 'location', 'city'],
                district: ['redInvoiceInfo', 'location', 'district'],
                ward: ['redInvoiceInfo', 'location', 'ward'],
                addressDetail: ['redInvoiceInfo', 'location', 'address'],
              }}
              fieldName={{
                city: ['redInvoiceInfo', 'cityId'],
                district: ['redInvoiceInfo', 'districtId'],
                ward: ['redInvoiceInfo', 'wardId'],
                addressDetail: ['redInvoiceInfo', 'addressNo'],
              }}
            /> */}
            <RedInvoiceWrapper>
              <RedInvoice form={form} required={true} />
            </RedInvoiceWrapper>
          </>
        ) : null}
      </CustomPanel>
    </Collapse>
  );
};

export default VATInvoiceFormSection;
